import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { Field, formValueSelector, reduxForm } from "redux-form";
import {
  CheckboxInput,
  IntlFieldGroup,
  SelectInput,
  TextInput,
} from "../../../common/form";
import { FormattedMessage, intlShape } from "react-intl";

import guaranteeTypes from "./enums/guaranteeTypes";
import guaranteeCategoryTypes from "./enums/guaranteeCategoryTypes";

import validationUtils from "../../../../utils/ValidationUtils";
import { GUARANTEE_VALIDATION_RULES } from "./guaranteeValidationRules";
import { GUARANTEES } from "../../../../utils/data/models";

class BasicGuaranteeFields extends React.Component {
  static generateLocalizedRules(model) {
    let newRules = { ...GUARANTEE_VALIDATION_RULES };

    GUARANTEES.localizedFields.map((field) => {
      Object.keys(model.localizations).map((locale) => {
        const fieldName = `localizations['${locale}'].${field}`;

        newRules[fieldName] = newRules[field];
      });
    });
    GUARANTEES.localizedFields.map((field) => {
      delete newRules[field];
    });

    return newRules;
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      showFormula: props.initialValues.guaranteeType === "FORMULA",
    };

    this.changeType = this.changeType.bind(this);
    this.generateLocalizedFields = this.generateLocalizedFields.bind(this);
  }

  getChildContext() {
    return {
      scene: this.props.scene,
    };
  }

  generateLocalizedFields() {
    return GUARANTEES.localizedFields.map((field) => {
      return (
        <IntlFieldGroup
          key={field}
          field={field}
          required={field == "name"}
          labelKey={`admin.guarantees.form.${field}`}
          localizations={this.props.initialValues.localizations}
        />
      );
    });
  }

  changeType(value) {
    this.setState({ ...this.state, showFormula: value === "FORMULA" });
    return value;
  }

  render() {
    const { quebecChecked, outOfQuebecChecked } = this.props;
    return (
      <form onSubmit={this.props.handleSubmit}>
        {this.generateLocalizedFields()}

        <Field
          id="additionalCode"
          name="additionalCode"
          component={TextInput}
          type="text"
          label={<FormattedMessage id="admin.guarantees.form.code" />}
        />

        <div className="two-columns-section">
          <Field
            id="isTaxableBenefitsFederal"
            name="isTaxableBenefitsFederal"
            component={CheckboxInput}
            groupClassName="checkbox-first"
            checkbox={{ value: true }}
            label={
              <FormattedMessage id="admin.guarantees.form.taxableIncomeFederal" />
            }
            normalize={(value) => !!value}
          />
          <Field
            id="isQuebecHealthPremium"
            name="isQuebecHealthPremium"
            component={CheckboxInput}
            groupClassName="checkbox-first"
            checkbox={{ value: true }}
            disabled={outOfQuebecChecked}
            label={
              <FormattedMessage id="admin.guarantees.form.quebecHealthPremium" />
            }
            normalize={(value) => !!value}
          />
          <Field
            id="isTaxableBenefitsQuebec"
            name="isTaxableBenefitsQuebec"
            component={CheckboxInput}
            groupClassName="checkbox-first"
            checkbox={{ value: true }}
            label={
              <FormattedMessage id="admin.guarantees.form.taxableIncomeQuebec" />
            }
            normalize={(value) => !!value}
          />
          <Field
            id="isTaxableBenefitsProvincial"
            name="isTaxableBenefitsProvincial"
            component={CheckboxInput}
            groupClassName="checkbox-first"
            checkbox={{ value: true }}
            disabled={quebecChecked}
            label={
              <FormattedMessage id="admin.guarantees.form.provincialTaxableBenefits" />
            }
            normalize={(value) => !!value}
          />
        </div>

        <Field
          id="guaranteeType"
          name="guaranteeType"
          component={SelectInput}
          options={guaranteeTypes}
          label={<FormattedMessage id="admin.guarantees.form.type" />}
          normalize={this.changeType}
          disabled={!this.props.add}
        />

        {this.state.showFormula && (
          <Field
          id="formulaDenominator"
          name="formulaDenominator"
          component={SelectInput}
          options={[
            { value: "1", text: "1" },
              { value: "10", text: "10" },
              { value: "100", text: "100" },
              { value: "1000", text: "1000" },
            ]}
            label={<FormattedMessage id="admin.guarantees.form.formula" />}
            />
          )}

          <Field
            id="category"
            name="category"
            component={SelectInput}
            options={guaranteeCategoryTypes}
            label={<FormattedMessage id="admin.guarantees.form.guaranteeCategory" />}
            required={true}
          />
      </form>
    );
  }
}

BasicGuaranteeFields.propTypes = {
  add: PropTypes.bool,
  initialValues: PropTypes.object,
  scene: PropTypes.string,
  validation: PropTypes.object,
  handleSubmit: PropTypes.func,
  quebecChecked: PropTypes.bool,
  outOfQuebecChecked: PropTypes.bool,
};

BasicGuaranteeFields.defaultProps = {
  scene: "",
};

BasicGuaranteeFields.contextTypes = {
  getData: PropTypes.func,
  intl: intlShape,
};

BasicGuaranteeFields.childContextTypes = {
  scene: PropTypes.string,
};

const selector = formValueSelector("guarantee");

const mapStateToProps = (state) => ({
  quebecChecked: !!selector(state, "isQuebecHealthPremium"),
  outOfQuebecChecked: !!selector(state, "isTaxableBenefitsProvincial"),
});

export default connect(mapStateToProps, null, null, { withRef: true })(
  reduxForm({
    form: "guarantee",
    validate: (values) =>
      validationUtils.validate(
        values,
        BasicGuaranteeFields.generateLocalizedRules(values)
      ),
  })(BasicGuaranteeFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/guarantees/BasicGuaranteeFields.js